import { callAgentForge } from './http';

export interface SendComposedEmailResponse {
  sent: boolean;
  result?: unknown;
}

// Sends the inline composer's email THROUGH agentforge (which proxies to Kula),
// instead of the frontend posting to the Kula ATS endpoints directly. Multipart
// so attachments ride along. The FormData fields match the agentforge
// /email/send handler: entity, recipient_ids (repeated), sender_id, subject,
// body, cc/bcc (repeated), ats_shared_email_id, scheduled_at, timezone,
// attachments (files).
export const sendComposedEmail = (
  form: FormData
): Promise<SendComposedEmailResponse> =>
  callAgentForge<SendComposedEmailResponse>({
    method: 'POST',
    url: '/email/send',
    body: form,
  });
